module.exports = __webpack_public_path__ + "404997503e5da0aa835b8b9c9e5c6cd1.svg";